import { getGlobalConfig, getHeadConfig } from './getConfig';
import { raygun } from '@ynap/clientside-monitoring';

export default (state) => {
    const { routes } = getHeadConfig(state);
    const { urlConfig } = getGlobalConfig(state);

    if (routes && routes.pdp) {
        return routes.pdp;
    }

    if (urlConfig && urlConfig.pdp && urlConfig.pdp.construct) return urlConfig.pdp.construct;

    const missingProperty = urlConfig ? (urlConfig.pdp ? 'urlConfig.pdp.construct' : 'urlConfig.pdp ') : `urlConfig`;
    raygun.helpers.agent('send', {
        error: new Error(`getPdpUrlTemplate error`),
        tags: [`error-getPdpUrlTemplate`, `${missingProperty} is not defined`],
    });
    return null;
};
